CSS.insert(`

    .deviceContainer {
        background: #f2f2f2;
        border-radius: 4px;
        margin-bottom: 10px;
    }

    .deviceBlock {
        margin: 0;
        padding: 6px 6px 12px 6px;
    }
    .deviceBlock:not(:last-child) {
        border-bottom: 1px solid #fff;
    }
    .deviceBlock > div {
        display: grid;
        grid-template-columns: 1fr min-content;
    }
    .deviceBlock > div img {
        width: 32px;
        margin: 6px 2px 6px 6px;
    }
    .deviceBlock > div div {
        font-size: 0.85em;
        margin-left: 10px;
    }   

    .deviceBlock > div div:first-child {
        grid-column: 1;
    }
    .deviceBlock > div div.buttons {
        grid-column: 2;
        grid-row: 1;
        align-self: end;
    }
    .deviceBlock > div div.cameras {
        grid-column: 1 / 3;
        grid-row: 2;
    }

    .deviceBlock > div div.cameras:not(:empty) {
        padding-left: 2px;
        padding-top: 6px;
        padding-bottom: 4px;
        font-size: 0.7em;
    } 
	
    .deviceBlock h3 {
        font-size: 1em;
        margin: 6px 0 -2px;

        display: flex;
        align-items: center;
    }

    .deviceBlock h3 i::before {
        font-size: 18px;
        margin-right: 4px;
    }

    .deviceBlock p {
        margin: 6px 0 0;
        font-size: 0.8em;
        display: flex;
        align-items: center;
    }
    .deviceBlock p i {
        margin-right: 4px;
    }
    .deviceBlock p i::before {
        font-size: 16px;
        color: #666;
    }


    .deviceBlock .widget.button {
        margin: 0 10px 4px 0;
    }
    .deviceBlock .widget.button button {
        border: none !important;
        width: 24px !important;
        min-width: 24px !important;
    }

    .deviceBlock .bullet {
        margin-left: 4px;
    }

    .deviceBlock .bullet[data-color=green] {
        color: var(--colors-green);
    }

    .deviceBlock .bullet[data-color=red] {
        color: var(--colors-red);
    }


    .deviceBlock .camera {
        display: grid;
        grid-template-columns: 20px 1fr;
        
        align-items: start;
        margin-top: 6px;

        cursor: pointer;
    }

    .deviceBlock .camera input {
        display: block;
        appearance: none;
        text-align: left;
    }
    
    [data-input-mode=keyboard] .deviceBlock .camera:has(input:focus) {
        outline: 2px solid var(--colors-named-focus);
		outline-inset: -1px;
        border-radius: 2px;
    }
    
    .deviceBlock .camera input:checked::before {
        position: absolute;
        content: '✔';
        display: block;
        margin-top: -1px;

        font-family: SalonIcon, SalonWidgets; 
        font-size: 16px; 
        --webkit-font-smoothing: antialiased; 
    }

    .deviceBlock .camera span {
        max-width: fit-content;
        overflow-x: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .deviceSettings {
        margin: 0;
    }


    /* Webcam barcode scanner custom styles */

    .webcam-barcode-scanner-preview video, 
    .webcam-barcode-scanner-preview canvas.snapshot {
        transition: filter 0.3s ease-in-out;
    }

    .webcam-barcode-scanner-preview.changing video,
    .webcam-barcode-scanner-preview.changing canvas.snapshot {
        filter: blur(3px) !important;
    }

    body.overlay .webcam-barcode-scanner-preview {
        opacity: 0.3 !important;
        filter: brightness(0.8) !important;
    }
    

`);
Devices = {
  initialize: function (parent, controller) {
    Devices._controller = controller;
    Devices._button = document.createElement('button');
    Devices._button.id = 'devices';
    Devices._button.update('\uE986');
    Devices._button.addEventListener('click', () => {
      Devices.show();
    });
    parent.appendChild(Devices._button);
  },
  show: function () {
    if (document.body.classList.contains('overlay')) {
      return;
    }
    let win = new Window({
      className: 'deviceWindow',
      pointer: {
        target: Devices._button,
        side: 'bottom',
        size: 20,
        corner: 8,
        distance: 16
      },
      width: 240,
      padding: 12,
      height: 'auto',
      onClose: () => delete Devices._button.dataset.state
    });
    let devices = Devices._controller.settings.devices;
    if (devices) {
      var _devices$receiptPrint, _devices$barcodeScann, _devices$customerPole, _devices$externalDisp;
      let container = new Element('div');
      container.classList.add('deviceContainer');
      win.appendChild(container);

      /* Receipt printer */

      if (((_devices$receiptPrint = devices.receiptPrinter) === null || _devices$receiptPrint === void 0 ? void 0 : _devices$receiptPrint.location) == 'internal') {
        var _devices$receiptPrint2, _devices$receiptPrint3, _devices$receiptPrint4;
        let icon;
        let method;
        switch (devices.receiptPrinter.method) {
          case 'driver':
            icon = '&#xE933;';
            method = 'Printer';
            break;
          case 'network':
            icon = '&#xE962;';
            method = 'Netwerk';
            break;
          case 'bluetooth':
            icon = '&#xE961;';
            method = 'Bluetooth';
            break;
          case 'usb':
            icon = '&#xE960;';
            method = 'USB';
            break;
          case 'serial':
            icon = '&#xE959;';
            method = 'Seriële poort';
            break;
        }
        let connected = DeviceManager.Internal.ReceiptPrinter.connected;
        let name = DeviceManager.Internal.ReceiptPrinter.name;
        let receiptPrinter = new Widgets.Panel(container, {
          className: 'deviceBlock',
          style: 'none',
          template: `
                        <div>
                            <h3>Bonnenprinter</h3>
                            <p>
                                <i data-icon="custom-character" data-icon-character="${icon}"></i>
                                ${connected ? name : method}
                            </p>
                        </div>
                        <div class='buttons'></div>
                    `
        });
        if (((_devices$receiptPrint2 = devices.receiptPrinter) === null || _devices$receiptPrint2 === void 0 ? void 0 : _devices$receiptPrint2.method) == 'bluetooth' || ((_devices$receiptPrint3 = devices.receiptPrinter) === null || _devices$receiptPrint3 === void 0 ? void 0 : _devices$receiptPrint3.method) == 'usb' || ((_devices$receiptPrint4 = devices.receiptPrinter) === null || _devices$receiptPrint4 === void 0 ? void 0 : _devices$receiptPrint4.method) == 'serial') {
          if (!connected) {
            new Widgets.Button(receiptPrinter.querySelector('.buttons'), {
              color: 'white',
              size: 'small',
              icon: {
                character: '\u002B',
                color: 'blue'
              },
              onClick: () => {
                win.close();
                DeviceManager.Internal.ReceiptPrinter.connect();
              }
            });
          } else {
            new Widgets.Button(receiptPrinter.querySelector('.buttons'), {
              color: 'white',
              size: 'small',
              icon: {
                character: '\u00D7',
                color: 'red'
              },
              onClick: () => {
                win.close();
                DeviceManager.Internal.ReceiptPrinter.disconnect();
              }
            });
          }
        }
      }

      /* Barcode scanner */

      if (((_devices$barcodeScann = devices.barcodeScanner) === null || _devices$barcodeScann === void 0 ? void 0 : _devices$barcodeScann.connection) == 'webcam') {
        let barcodeScanner = new Widgets.Panel(container, {
          className: 'deviceBlock',
          style: 'none',
          template: `
                        <div>
                            <h3>Barcode scanner</h3>
                            <p>
                                <i data-icon="custom-character" data-icon-character="&#xE97f;"></i>
                                Webcam
                            </p>
                        </div>
                        <div class='buttons'></div>
                        <div class='cameras'></div>
                    `
        });
        if (!DeviceManager.Internal.BarcodeScanner.connected) {
          new Widgets.Button(barcodeScanner.querySelector('.buttons'), {
            color: 'white',
            size: 'small',
            icon: {
              character: '\uE98c',
              color: 'green'
            },
            onClick: () => {
              win.close();
              DeviceManager.Internal.BarcodeScanner.start();
            }
          });
        } else {
          new Widgets.Button(barcodeScanner.querySelector('.buttons'), {
            color: 'white',
            size: 'small',
            icon: {
              character: '\uE98d',
              color: 'red'
            },
            onClick: () => {
              win.close();
              DeviceManager.Internal.BarcodeScanner.stop();
            }
          });
          let container = barcodeScanner.querySelector('.cameras');
          let cameras = DeviceManager.Internal.BarcodeScanner.getCameras();
          for (let camera of cameras) {
            let item = new Element('label');
            item.classList.add('camera');
            let radio = new Element('input', {
              type: 'radio',
              name: 'camera',
              value: camera.deviceId,
              checked: camera.selected,
              tabIndex: 0
            });
            radio.addEventListener('change', () => {
              win.close();
              DeviceManager.Internal.BarcodeScanner.change(camera.deviceId);
            });
            let text = new Element('span');
            text.innerHTML = camera.label;
            item.appendChild(radio);
            item.appendChild(text);
            container.appendChild(item);
          }
        }
      } else {
        let icon = '&#xE97e;';
        let method = 'Toetsenbord emulatie';
        if (devices.barcodeScanner.connection == 'hid') {
          icon = '&#xE98b;';
          method = devices.barcodeScanner.device.productName;
        }
        new Widgets.Panel(container, {
          className: 'deviceBlock',
          style: 'none',
          template: `
                        <div>
                            <h3>Barcode scanner</h3>
                            <p>
                                <i data-icon="custom-character" data-icon-character="${icon}"></i>
                                ${method}
                            </p>
                        </div>
                    `
        });
      }

      /* Customer Pole */

      if (((_devices$customerPole = devices.customerPole) === null || _devices$customerPole === void 0 ? void 0 : _devices$customerPole.connection) == 'serial') {
        let customerPole = new Widgets.Panel(container, {
          className: 'deviceBlock',
          style: 'none',
          template: `
                        <div>
                            <h3>Klantendisplay</h3>
                            <p>
                                <i data-icon="custom-character" data-icon-character="&#xE959;"></i>
                                Seriële poort
                            </p>
                        </div>
                        <div class='buttons'></div>
                    `
        });
        if (!DeviceManager.Internal.CustomerPole.connected) {
          new Widgets.Button(customerPole.querySelector('.buttons'), {
            color: 'white',
            size: 'small',
            icon: {
              character: '\u002B',
              color: 'blue'
            },
            onClick: () => {
              win.close();
              DeviceManager.Internal.CustomerPole.start();
            }
          });
        } else {
          new Widgets.Button(customerPole.querySelector('.buttons'), {
            color: 'white',
            size: 'small',
            icon: {
              character: '\u00D7',
              color: 'red'
            },
            onClick: () => {
              win.close();
              DeviceManager.Internal.CustomerPole.stop();
            }
          });
        }
      }

      /* External screen */

      if ((_devices$externalDisp = devices.externalDisplay) !== null && _devices$externalDisp !== void 0 && _devices$externalDisp.method && Devices._controller.devices.isExternalDisplayManual()) {
        let icon = '&#xE944;';
        let method = devices.externalDisplay.display;
        if (devices.externalDisplay.method == 'cast') {
          icon = '&#xE964;';
          method = 'Cast naar scherm';
        }
        let externalDisplay = new Widgets.Panel(container, {
          className: 'deviceBlock',
          style: 'none',
          template: `
                        <div>
                            <h3>Extern scherm</h3>
                            <p>
                                <i data-icon="custom-character" data-icon-character="${icon}"></i>
                                ${method}
                            </p>
                            
                        </div>
                        <div class='buttons'></div>
                    `
        });
        if (!Devices._controller.devices.isExternalDisplayOpen()) {
          new Widgets.Button(externalDisplay.querySelector('.buttons'), {
            color: 'white',
            size: 'small',
            icon: {
              character: '\uE98c',
              color: 'green'
            },
            onClick: () => {
              win.close();
              Devices._controller.devices.openExternalDisplay();
            }
          });
        } else {
          new Widgets.Button(externalDisplay.querySelector('.buttons'), {
            color: 'white',
            size: 'small',
            icon: {
              character: '\uE98d',
              color: 'red'
            },
            onClick: () => {
              win.close();
              Devices._controller.devices.closeExternalDisplay();
            }
          });
        }
      }
    }

    /* SalonhubPOS status */

    if (Devices._controller.devices.external) {
      let container = new Element('div');
      container.classList.add('deviceContainer');
      win.appendChild(container);
      let version = Devices._controller.devices.external.getVersion();
      new Widgets.Panel(container, {
        className: 'deviceBlock',
        style: 'none',
        template: `
                    <div>
                        <p>
                            <i data-icon="custom-character" data-icon-character="&#xE96d;"></i>
                            SalonhubPOS ${version || ''}
                            <span class='bullet' data-color='${Devices._controller.devices.external.enabled ? 'green' : 'red'}'>●</span>
                        </p>
                    </div>
                `
      });
    }
    new Widgets.Button(win, {
      className: 'deviceSettings',
      title: 'Apparaat instellingen...',
      icon: 'settings',
      style: 'none',
      onClick: () => {
        win.close();
        let actors = Devices._controller.getActors();
        let admin = actors.filter(i => i.stage == 'admin' && i.actor == 'main').pop();
        if (admin) {
          Devices._controller.main.loader.change({
            ...admin,
            path: 'index/devices'
          });
        } else {
          let settings = actors.filter(i => i.stage == 'admin' && i.actor == 'settings').pop();
          if (settings) {
            Devices._controller.main.loader.change({
              ...settings,
              path: 'index/devices'
            });
          }
        }
      }
    });
    win.show();
    Devices._button.dataset.state = 'active';
  }
};
//# sourceMappingURL=devices.js.map
